import apiClient from '@u/apiClient'
import GetPersonListController from '@/wayfinder/actions/App/Http/Controllers/Person/GetPersonListController'
import GetPersonByIdController from '@/wayfinder/actions/App/Http/Controllers/Person/GetPersonByIdController'
import GetPersonByIdWithAllRelationsController from '@/wayfinder/actions/App/Http/Controllers/Person/GetPersonByIdWithAllRelationsController'
import CreatePersonController from '@/wayfinder/actions/App/Http/Controllers/Person/CreatePersonController'
import UpdatePersonController from '@/wayfinder/actions/App/Http/Controllers/Person/UpdatePersonController'
import UpdateChiftExternalReferenceController from '@/wayfinder/actions/App/Http/Controllers/Person/UpdateChiftExternalReferenceController'
import UpdatePersonVigilanceController from '@/wayfinder/actions/App/Http/Controllers/Person/UpdatePersonVigilanceController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

const baseErrors = {}

export default {
  deletePerson({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .delete(`/api/person/${payload.id}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  undoDeletePerson: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/api/person/${payload.id}/undo-delete`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // region fetch

  fetchPersonList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetPersonListController.get(), { params: payload.params })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchPersonById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetPersonByIdController.get({ mergeablePerson: payload.person_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchPersonByIdWithAllRelations({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetPersonByIdWithAllRelationsController.get({
            mergeablePerson: payload.person_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewPerson({ commit }, predefinedRole) {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'person' } }))
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  storePerson({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreatePersonController.post(), payload.person)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updatePerson({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdatePersonController.put({ person: payload.id }),
          payload.person
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  /**
   * Raise or clear the vigilance flag of a contact.
   *
   * Its own endpoint, not updatePerson: the generic person update is open to
   * manage_content, while this one is guarded by manage_contact_vigilance, and
   * the API strips the vigilance columns out of the generic payload.
   *
   * A null status clears the flag; the API then empties the reason, the author
   * and the date along with it.
   */
  updatePersonVigilance({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(UpdatePersonVigilanceController.put({ person: payload.id }), {
          vigilance_status: payload.vigilance_status ?? null,
          vigilance_reason: payload.vigilance_reason ?? null
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  linkPersonToChiftCustomer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateChiftExternalReferenceController.post({
            person: payload.person_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
